<aside class="sidebar" [class.rtl]="currentLanguage === 'ar'">
  <div class="brand">
    <a routerLink="/dashboard" style="cursor: pointer;">
      <img src="assets/images/sidebar-logo.png" alt="AVSEC logo" class="brand-logo" />
    </a>
  </div>

  <!-- Mobile close button -->
  <button class="close-sidebar-btn" aria-label="Close sidebar" (click)="uiService.toggleSidebar(false)">
    <i class="bi bi-x-lg"></i>
  </button>

  <nav class="nav-list">
    <a routerLink="/dashboard" routerLinkActive="active" class="nav-item">
      <i class="bi bi-grid-fill"></i>
      <span class="label">{{ 'sidebar.dashboard' | translate }}</span>
    </a>
    <a routerLink="/requests/drafts" routerLinkActive="active" class="nav-item" aria-label="Drafts">
      <i class="bi bi-file-earmark-text"></i>
      <span class="label">{{ 'sidebar.drafts' | translate }}</span>
    </a>
    <a routerLink="/requests/inbox" [class.active]="isNavItemActive('inbox')" class="nav-item" aria-label="Inbox">
      <i class="bi bi-inbox-fill"></i>
      <span class="label">{{ 'sidebar.inbox' | translate }}</span>
    </a>
    <a routerLink="/requests/sent" [class.active]="isNavItemActive('sent')" class="nav-item" aria-label="Sent">
      <i class="bi bi-send-fill"></i>
      <span class="label">{{ 'sidebar.sent' | translate }}</span>
    </a>
    <a routerLink="/requests/completed" [class.active]="isNavItemActive('completed')" class="nav-item" aria-label="Completed">
      <i class="bi bi-check2-circle"></i>
      <span class="label">{{ 'sidebar.completed' | translate }}</span>
    </a>
    <a routerLink="/requests/my-sent" [class.active]="isNavItemActive('my-sent')" class="nav-item" aria-label="My Requests">
      <i class="bi bi-arrow-return-right"></i>
      <span class="label">{{ 'sidebar.mySent' | translate }}</span>
    </a>
  </nav>
</aside>
